// extracted by mini-css-extract-plugin
export default {"header":"PhNSBW","action":"sH3Qn_","actionButtons":"Qp7pEc"};